import { render } from "./blogView.vue?vue&type=template&id=2147a0d8"
import script from "./blogView.vue?vue&type=script&lang=js"
export * from "./blogView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__